"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Context_1 = require("./Context");
class EditorFactory {
    getBestEditor(node, factory, context) {
        const e = this.getEditors(node, factory, context || new Context_1.Context());
        e.sort((a, b) => b.priority - a.priority);
        return e[0];
    }
}
exports.EditorFactory = EditorFactory;
class ComposableEditorFactory extends EditorFactory {
    constructor(factories) {
        super();
        this.factories = factories;
    }
    getEditors(node, factory, context) {
        return new Array().concat(...this.factories.map(f => f.getEditors(node, factory, context)));
    }
}
exports.ComposableEditorFactory = ComposableEditorFactory;
//# sourceMappingURL=EditorFactory.js.map